export default __webpack_public_path__ + "static/error-29e0bde40639e1ca396e5ab07e1853d2.svg";